import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import ExportOptionsMenu from './ExportOptionsMenu';
import ExportButton from './ExportButton';
import materialTheme from '../reactMaterialTheme';

const ExportCreatives = props => {
  const getCreatives = () => {
    if (
      props.CreativeGroupService.group &&
      props.CreativeGroupService.group.creativePreviews &&
      props.CreativeGroupService.group.creativePreviews.length > 0
    ) {
      return props.CreativeGroupService.group.creativePreviews;
    } else {
      return [props.CreativeService.creative];
    }
  };

  return props.showBulkExport() ? (
    <MuiThemeProvider theme={materialTheme}>
      <ExportOptionsMenu {...props} getCreatives={getCreatives} />
    </MuiThemeProvider>
  ) : (
    <ExportButton {...props} getCreatives={getCreatives} />
  );
};

ExportCreatives.propTypes = {
  rtbVersion: PropTypes.string.isRequired,
  showBulkExport: PropTypes.func,
  AdMarkupService: PropTypes.object.isRequired,
  CreativeService: PropTypes.object.isRequired,
  CreativeGroupService: PropTypes.object.isRequired,
  FlashService: PropTypes.object.isRequired
};

ExportCreatives.defaultProps = {
  showBulkExport: () => false
};

export default ExportCreatives;
